import { useId } from 'react';
import { Dropdown } from '../Dropdown';
import { FloatingField } from '../FloatingField';
import { FormCard } from '../FormCard';
import { FixedField, SelectShell } from './FloatingSelectField.styles';
import type { FloatingSelectFieldProps } from './FloatingSelectField.types';

export function FloatingSelectField({
  label,
  options,
  value,
  onChange,
  placeholder,
  required = true,
  error,
  fixedValueLabel,
  'aria-label': ariaLabel,
  disabled = false,
}: FloatingSelectFieldProps) {
  const errorId = useId();

  if (fixedValueLabel !== undefined) {
    return <FixedField aria-label={ariaLabel ?? label}>{fixedValueLabel}</FixedField>;
  }

  return (
    <SelectShell>
      <FormCard>
        <FloatingField
          label={label}
          hasValue={Boolean(value)}
          required={required}
          error={error}
          errorId={errorId}
        >
          <Dropdown
            options={options}
            value={value}
            placeholder={placeholder ?? (required ? `${label}*` : label)}
            onChange={onChange}
            aria-label={ariaLabel ?? label}
            aria-describedby={error ? errorId : undefined}
            hasError={Boolean(error)}
            disabled={disabled}
          />
        </FloatingField>
      </FormCard>
    </SelectShell>
  );
}
